export enum ProductTypeEnum {
  RealState = 'real_estate',
  RealEstateParent = 'real_estate_parent'
}
